import { render, staticRenderFns } from "./PlatformInfo.vue?vue&type=template&id=06fddbaa&scoped=true"
import script from "./PlatformInfo.vue?vue&type=script&lang=js"
export * from "./PlatformInfo.vue?vue&type=script&lang=js"
import style0 from "./PlatformInfo.vue?vue&type=style&index=0&id=06fddbaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fddbaa",
  null
  
)

export default component.exports